import { createReducer, on } from '@ngrx/store';
import { Group, GroupsListMeta } from '../models/group.model';
import * as GroupsActions from './groups.actions';
import { ApiTableFilter } from '../../../shared/models/table-filter.model';

export interface GroupsQueryState {
  search?: string;
  filters?: ApiTableFilter[];
  filterLink?: string;
  sort?: string;
  sortDirection?: string;
}

export interface GroupsState {
  groups: Group[];
  meta: GroupsListMeta | null;
  isLoading: boolean;
  isSubmitting: boolean;
  isDeleting: boolean;
  isBulkDeleting: boolean;
  error: string | null;
  lastQuery: GroupsQueryState;
}

const initialState: GroupsState = {
  groups: [],
  meta: null,
  isLoading: false,
  isSubmitting: false,
  isDeleting: false,
  isBulkDeleting: false,
  error: null,
  lastQuery: {},
};

export const groupsReducer = createReducer(
  initialState,

  on(GroupsActions.loadGroups, (state, action) => ({
    ...state,
    isLoading: true,
    error: null,
    lastQuery: {
      search: action.search,
      filters: action.filters,
      filterLink: action.filterLink,
      sort: action.sort,
      sortDirection: action.sortDirection,
    },
  })),
  on(GroupsActions.loadGroupsSuccess, (state, { groups, meta }) => ({
    ...state,
    groups,
    meta,
    isLoading: false,
  })),
  on(GroupsActions.loadGroupsFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error,
  })),

  on(GroupsActions.submitGroup, (state) => ({
    ...state,
    isSubmitting: true,
    error: null,
  })),
  on(GroupsActions.submitGroupSuccess, (state) => ({
    ...state,
    isSubmitting: false,
  })),
  on(GroupsActions.submitGroupFailure, (state, { error }) => ({
    ...state,
    isSubmitting: false,
    error,
  })),

  on(GroupsActions.deleteGroup, (state) => ({
    ...state,
    isDeleting: true,
    error: null,
  })),
  on(GroupsActions.deleteGroupSuccess, (state) => ({
    ...state,
    isDeleting: false,
  })),
  on(GroupsActions.deleteGroupFailure, (state, { error }) => ({
    ...state,
    isDeleting: false,
    error,
  })),

  on(GroupsActions.bulkDeleteGroups, (state) => ({
    ...state,
    isBulkDeleting: true,
    error: null,
  })),
  on(GroupsActions.bulkDeleteGroupsSuccess, (state) => ({
    ...state,
    isBulkDeleting: false,
  })),
  on(GroupsActions.bulkDeleteGroupsFailure, (state, { error }) => ({
    ...state,
    isBulkDeleting: false,
    error,
  })),

  on(GroupsActions.resetGroupsState, () => initialState),
);
